export default "__VITE_ASSET__Cbe0vxjh__"